import React from 'react';
import PropTypes from 'prop-types';


import { TwitchExample } from './components';
import { Container } from './styles';

function ChatSimple({ data, styles }) {
  return (
    <Container>
      <TwitchExample styles={styles} />
    </Container>
  );
}

ChatSimple.propTypes = {
  data: PropTypes.shape({
    platform: PropTypes.oneOf(['twitch', 'kick']),
    username: PropTypes.string,
  }),
  styles: PropTypes.shape({
    user: PropTypes.shape({
      letterSpacing: PropTypes.number,
      showIcons: PropTypes.bool,
      size: PropTypes.number,
    }),
    message: PropTypes.shape({
      color: PropTypes.string,
      letterSpacing: PropTypes.number,
      size: PropTypes.number,
    }),
  }),
};

ChatSimple.defaultProps = {
  data: {
    platform: 'twitch',
    username: 'mikelgartziia',
  },
  styles: {
    user: {
      letterSpacing: 1,
      shadowSize: 0,
      shadowColor: '#ffffff',
      showIcons: true,
      size: 15,
    },
    message: {
      color: '#efeff1',
      letterSpacing: 1,
      shadowSize: 0,
      shadowColor: '#ffffff',
      size: 15,
    },
  },
};

export default ChatSimple;
